import type { PropsWithChildren, FunctionComponent } from 'react'
import { useEffect } from 'react'
import FeatureEducationModal from '../../legacy/components/FeatureHighlights/FeatureEducationModal'
import useFeatureEducation from '../../legacy/components/FeatureHighlights/useFeatureEducation'
import { AppContentContainer } from '../../gin-and-tonic/containers/app-content-container/AppContentContainer'
import ErrorBoundary from '../../legacy/components/ErrorBoundary'
import { type DashRouteComponentProps } from '../../legacy/dash-components/dash-route/utils/dashRoute.types'
import { DASH_NAV_V2_HEIGHT } from '../../legacy/common/theme'
import { ContactHeader } from '../../routes/utils/ContactHeader'
import { MenuBarTop } from '../../gin-and-tonic/containers/nav-v2/components/MenuBarTop'
import { useNavHierarchyAdmin } from '../../gin-and-tonic/containers/nav-v2/NavMenuHierarchy'
import { LeftShortcutsPaneAdmin } from '../../gin-and-tonic/containers/nav-v2/components/LeftShortcutsPane/LeftShortcutsPaneAdmin'
import { useWindowSizeIsWide } from '../../utils/window/windows.hooks'
import { useNavContext } from '../../gin-and-tonic/containers/nav/utils/NavContext'
import { useDatadogPrivacy } from '../../gin-and-tonic/containers/datadog-privacy/DatadogPrivacy'
import { AiPageLayout } from '../../utils/contexts/ai/AiPageLayout'
import { AdminSectionRoutes } from './AdminSectionRoutes'

interface Props extends DashRouteComponentProps {}

export const AdminSection: FunctionComponent<PropsWithChildren<Props>> = ({
  location: { pathname },
}) => {
  const { navMenuHierarchy } = useNavHierarchyAdmin()
  const { isNavVisible } = useNavContext()

  const { isOpen, onOpen, onClose, onClick, feature } = useFeatureEducation(pathname)

  useEffect(() => {
    if (isOpen) {
      onOpen()
    }
  }, [isOpen, onOpen, pathname])

  const isWide = useWindowSizeIsWide()

  const topPadding = isNavVisible ? DASH_NAV_V2_HEIGHT : '0px'
  const leftPadding = '0px'

  // Since admin has more privileged or sensitive tools, we mask user input by default
  useDatadogPrivacy('mask-user-input')

  return (
    <>
      {isNavVisible && <MenuBarTop navMenuHierarchy={navMenuHierarchy} />}

      <div
        css={{
          display: 'flex',
          position: 'absolute',

          left: leftPadding,
          top: topPadding,

          width: `calc(100% - ${leftPadding})`,
          minHeight: `calc(100% - ${topPadding})`,
          height: `calc(100% - ${topPadding})`,
        }}
      >
        {isNavVisible && isWide && <LeftShortcutsPaneAdmin />}

        <FeatureEducationModal
          // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
          isOpen={isOpen}
          onClose={onClose}
          onClick={onClick}
          // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
          feature={feature}
        />
        <AiPageLayout>
          <AppContentContainer>
            <ContactHeader />
            <ErrorBoundary pathname={pathname}>
              <AdminSectionRoutes />
            </ErrorBoundary>
          </AppContentContainer>
        </AiPageLayout>
      </div>
    </>
  )
}
